<template>
  <div class="form_wrap">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="农场名称" prop="farmName" required>
        <span class="form-txt">{{ ruleForm.farmName }}</span>
      </el-form-item>
      <el-form-item label="农事类型" prop="sysMissionCategoryName" required>
        <span class="form-txt">{{ ruleForm.sysMissionCategoryName }}</span>
      </el-form-item>
      <el-form-item label="采收品种" prop="cropId">
        <span class="form-txt">{{ ruleForm.cropName }}</span>
      </el-form-item>
      <el-form-item label="采收地块" prop="landIds">
        <el-button
          v-if="!ruleForm.landIds.length"
          round
          size="medium"
          class="select-btn"
          @click="chooseLandHandle"
          >选择地块</el-button
        >
        <el-button
          v-else
          round
          size="medium"
          type="text"
          @click="chooseLandHandle"
        >
          {{
            `已选择${ruleForm.landIds.length}个地块(共${ruleForm.landAcre}亩)`
          }}
        </el-button>
        <!-- <div
          class="land_id"
          :title="ruleForm.landIds && ruleForm.landIds.join(',')"
        >
          {{ ruleForm.landIds ? ruleForm.landIds.join(",") : "--" }}
        </div> -->
      </el-form-item>
      <el-form-item label="采收重量" prop="pickOutput"
        ><el-input v-model="ruleForm.pickOutput" maxlength="9">
          <template slot="append">公斤</template>
        </el-input>
      </el-form-item>

      <el-form-item label="作业方式" prop="operationMode">
        <el-radio-group v-model="ruleForm.operationMode">
          <el-radio :label="0">人工</el-radio>
          <el-radio :label="1">机械</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="采收时间" prop="pickTimeStr">
        <el-date-picker
          type="datetime"
          placeholder="请选择采收时间"
          v-model="ruleForm.pickTimeStr"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          :picker-options="pickerDateOptions"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="采收产品" prop="goodsId">
        <el-select
          class="prodcut_input"
          v-model="ruleForm.goodsId"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in goodsIdList"
            :key="item.id"
            :label="item.goodsName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button class="prodcut_add" @click="addProductFn">添加</el-button>
      </el-form-item>

      <el-form-item label="操作人" prop="chargeUserId">
        <el-select
          class="prodcut_input"
          v-model="ruleForm.chargeUserId"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in chargeUserList"
            :key="item.userId"
            :label="item.companyUserName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
        <el-button class="prodcut_add" @click="addStaffFn">添加</el-button>
      </el-form-item>

      <el-form-item label="产品等级" prop="goodLevel">
        <el-select
          class="goodLevel-ipt"
          v-model="ruleForm.goodLevel"
          placeholder="请选择产品等级"
        >
          <el-option
            v-for="(item, index) in goodsLevelList"
            :label="item.name"
            :value="item.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :rows="7"
          maxlength="200"
          show-word-limit
          v-model="ruleForm.remark"
        ></el-input>
      </el-form-item>
      <!-- 农机信息 -->
      <agric-info :agricInfo="njList"></agric-info>
      <form-btn @submitForm="submitForm" @deleteForm="deleteForm"></form-btn>
    </el-form>
    <AddProductModal
      :cropId="cropId"
      :cropName="ruleForm.cropName"
      :showFlag.sync="showProductDialog"
      @update:showFlag="(val) => (showProductDialog = val)"
      @updateProductList="getCropList"
      @updateProductId="(val) => (ruleForm.goodsId = val)"
    />
    <AddStaff
      :showFlag.sync="showAddStaffFlag"
      @update:showFlag="(val) => (showAddStaffFlag = val)"
      @updateMissionList="getOperateList()"
      @updateMissionId="(val) => (ruleForm.chargeUserId = val)"
    />
    <div class="land-shade" v-if="showLand && !closeOpen"></div>
    <div v-if="showLand && !closeOpen" class="land-content">
      <div class="land-content-list">
        <choose-land
          :selectLandLists="selectLandLists"
          :selectCropId="'1'"
          @submit="chooseLandFun"
          @selectLandList="selectLandList"
        ></choose-land>
      </div>
      <button class="close-btn" @click="closeHandle">
        <img src="@/assets/images/common/bg-close.png" alt="" />
      </button>
    </div>
  </div>
</template>

<script>
import FormBtn from "../components/FormBtn";
import AddProductModal from "../components/AddProductModal";
import AddStaff from "../components/AddStaff";
import ChooseLand from "../ChooseLand/Index";
import AgricInfo from "../components/AgricInfo";
import { mapState, mapGetters } from "vuex";
import {
  getDetail,
  getCropList,
  saveMission,
  saveAndAudit,
  getDel,
} from "@/api/request/snkd.produce";
import { getOperateList } from "@/api/request/snkd.user";
import { getStorage } from "@/utils/storage";

export default {
  name: "RecoveryForm",
  components: {
    AddProductModal,
    AddStaff,
    FormBtn,
    ChooseLand,
    AgricInfo,
  },
  props: {
    isBack: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isBack(val) {
      if (val) {
        const ruleForm = {
          ...this.ruleForm,
          selectLandLists: this.selectLandLists,
        };
        if (JSON.stringify(this.originForm) === JSON.stringify(ruleForm)) {
          this.$router.go(-1);
        } else {
          const h = this.$createElement;
          this.$confirm("", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "confirm-dialog",
            message: h("div", [
              h(
                "p",
                {
                  style:
                    "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
                },
                `当前页面未保存！`
              ),
              h(
                "p",
                {
                  style:
                    "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
                },
                [
                  h(
                    "span",
                    null,
                    "是否确定返回？返回后将不对修改后的数据进行保存"
                  ),
                ]
              ),
            ]),
            type: "warning",
          })
            .then(async () => {
              this.$router.go(-1);
            })
            .catch(() => {
              this.$emit("updateStatus", false);
            });
        }
      }
    },
  },
  data() {
    return {
      curId: "",
      farmId: "",
      companyId: "",
      categoryType: 0,
      cropId: 0,
      showProductDialog: false, //添加农产品弹窗表示
      showAddStaffFlag: false, //添加员工弹窗
      selectLandLists: [],
      showLand: false,
      njList: [], //农机信息
      originForm: {}, //原始数据
      ruleForm: {
        farmName: "",
        sysMissionCategoryName: "",
        goodLevel: "", //产品等级
        cropId: "", // 作物id
        cropName: "",
        operationMode: 0, //采收方式 0 人工 1 机械
        goodsId: "", //采收产品
        remark: "", //备注
        pickTimeStr: "", //采收时间
        chargeUserId: "", //采收人
        pickOutput: "", //采收重量
        landIds: [], // 地块id
      },
      rules: {
        cropId: [
          { required: true, message: "请输入采收品种", trigger: "blur" },
        ],
        landIds: [
          { required: true, message: "请选择采收地块", trigger: "change" },
        ],
        pickOutput: [
          {
            required: true,
            pattern: /^([0-9]\d*(\.\d{1,1})?)$/,
            message: "请输入正数，最多一位小数",
          },
        ],
        operationMode: [
          { required: true, message: "请选择采收方式", trigger: "change" },
        ],
        pickTimeStr: [
          { required: true, message: "请选择采收时间", trigger: "change" },
        ],
        goodsId: [
          { required: true, message: "请选择采收产品", trigger: "change" },
        ],
        chargeUserId: [
          { required: true, message: "请选择操作人", trigger: "change" },
        ],
        goodLevel: [
          { required: true, message: "请选择产品等级", trigger: "change" },
        ],
        remark: [],
      },
      //产品等级
      goodsLevelList: [
        { value: 1, name: "一等品" },
        { value: 2, name: "二等品" },
        { value: 3, name: "三等品" },
        { value: 4, name: "四等品" },
        { value: 5, name: "五等品" },
      ],
      //操作人
      chargeUserList: [],
      goodsIdList: [],
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    this.curId = this.$route.query.id;
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    this.getOperateList();
    this.getDetail();
  },
  computed: {
    ...mapState("damage", {
      closeOpen: "closeOpen",
    }),
    ...mapGetters("damage", ["hadSelectedLandList", "showLandList"]),
    //求和
    totalAcre() {
      return this.calcLandAcre(this.selectLandLists);
    },
  },
  methods: {
    submitForm(type) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log("校验通过");
          this.saveForm(type);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * type: 1、保存 2、保存并提交审核
     */
    async saveForm(type) {
      let params = {
        categoryType: this.categoryType,
        chargeUserId: this.ruleForm.chargeUserId,
        id: this.curId,
        landIds: this.ruleForm.landIds,
        operationMode: this.ruleForm.operationMode,
        pickStashVO: {
          cropId: this.ruleForm.cropId,
          cropName: this.ruleForm.cropName,
          goodLevel: this.ruleForm.goodLevel,
          goodsId: this.ruleForm.goodsId,
          pickOutput: this.ruleForm.pickOutput,
          pickTimeStr: this.ruleForm.pickTimeStr,
          pickUserId: this.ruleForm.pickUserId,
          remark: this.ruleForm.remark,
          type: 2,
        },
      };
      console.log("params", params, type);
      if (type === 1) {
        await saveMission(params).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.$message.success("保存成功");
            this.$router.go(-1);
          }
          console.log(respCode, obj);
        });
      } else {
        await saveAndAudit(params).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.$message.success("提交审核成功");
            this.$router.go(-1);
          } else if (respCode === 40012) {
            // 审核不成功
            this.auditFail();
          }
          console.log(respCode, obj);
        });
      }
    },
    async getDetail() {
      await getDetail({
        id: this.curId,
        companyId: this.companyId,
      }).then((res) => {
        const { respCode, obj } = res;
        console.log(respCode, obj);

        if (respCode === 0) {
          this.categoryType = obj.categoryType;
          this.ruleForm.farmName = obj.farmName;
          this.ruleForm.sysMissionCategoryName = obj.sysMissionCategoryName;
          this.ruleForm.operationMode = obj.operationMode;
          this.ruleForm.cropName = obj.pickStashVO.cropName;
          this.ruleForm.cropId = obj.pickStashVO.cropId;
          this.cropId = obj.pickStashVO.cropId * 1;
          this.ruleForm.pickOutput = obj.pickStashVO.pickOutput + "";
          this.ruleForm.pickTimeStr = obj.pickStashVO.pickTimeStr;
          this.ruleForm.goodsId = obj.pickStashVO.goodsId;
          this.ruleForm.goodLevel = obj.pickStashVO.goodLevel;
          this.ruleForm.chargeUserId = obj.chargeUserId;
          this.ruleForm.remark = obj.pickStashVO.remark;
          //地块
          this.selectLandLists = obj.landList;
          this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
          this.ruleForm.landAcre = this.calcLandAcre(this.selectLandLists);
          //删除农机信息的第一条数据
          this.njList = obj.njList || [];
          this.getCropList();
        }
        let originForm = {
          ...this.ruleForm,
          selectLandLists: this.selectLandLists,
        };
        this.originForm = JSON.parse(JSON.stringify(originForm));
      });
    },
    auditFail() {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "知道了",
        showCancelButton: false,
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `审核未通过！`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "当前数据未审核成功，请手动重新审核。")]
          ),
        ]),
        type: "warning",
      })
        .then(() => {})
        .catch(() => {});
    },
    async getCropList() {
      await getCropList({
        companyId: this.companyId,
        cropId: this.ruleForm.cropId,
        farmId: this.farmId,
      }).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.goodsIdList = obj || [];
        }
      });
    },
    //操作人列表
    async getOperateList() {
      await getOperateList({
        companyId: this.companyId,
        farmId: this.farmId,
      }).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.chargeUserList = obj || [];
        }
      });
    },
    //打开添加农产品弹窗
    addProductFn() {
      this.showProductDialog = true;
    },
    //打开添加员工弹窗
    addStaffFn() {
      this.showAddStaffFlag = true;
    },
    //选择地块
    selectLandList(evt) {
      this.selectLandLists = evt;
    },
    //打开地块弹框
    chooseLandHandle() {
      console.log("chooseLandHandle");
      this.$store.commit("damage/closeLand", false);
      this.$store.commit("damage/changeShowLandMode", "ListMode");
      this.showLand = true;
    },
    // 地块选择确定
    chooseLandFun() {
      this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
      this.ruleForm.landAcre = this.totalAcre;
    },
    //关闭地块弹框
    closeHandle() {
      this.showLand = false;
      this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
      this.ruleForm.landAcre = this.totalAcre;
      //清空筛选条件
      this.$store.commit("damage/clearPageAllStatus");
    },
    //求和
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => {
          if (cur.statisticsLandAcre) {
            return total + cur.statisticsLandAcre;
          } else {
            return total + cur.landAcre;
          }
        }, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    async deleteForm() {
      await getDel({
        idList: [this.curId],
      }).then((res) => {
        const { respCode } = res;
        if (respCode === 0) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.$router.go(-1);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.form_wrap {
  background: #fff;
  .demo-ruleForm {
    padding: 40px;
    width: 50%;
    margin: 0 auto;
  }
  .form-txt {
    color: #c0c4cc;
  }
  .select-btn {
    border: 1px solid #64c3a4;
    color: #64c3a4;
  }
  .crop_name {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 5px;
    border-radius: 20px;
    background: #eaeef4;
    color: #333;
    font-size: 14px;
    width: 100px;
  }
  .land_id {
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    font-weight: 400;
    color: #b2b2b2;
    width: 500px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep .prodcut_input {
    width: 390px !important;
  }
  .prodcut_add {
    margin-left: 20px;
  }
  .submit_wrap {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    button {
      width: 120px;
    }
  }
  ::v-deep .goodLevel-ipt.el-select {
    width: 100%;
  }
  .el-button--medium.el-button--text {
    padding: 0;
  }
  .land-shade {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    opacity: 0.3;
    z-index: 5;
    position: absolute;
    top: 0px;
    left: 0;
  }
  .land-content {
    position: absolute;
    top: 13%;
    left: 0;
    right: 0;
    width: 1200px;
    height: 85%;
    z-index: 10;
    margin: 0 auto;
    .land-content-list {
      width: 100%;
      height: 95%;
      background-color: #fff;
      margin: 0 auto;
      border-radius: 10px;
      padding: 10px;
      position: relative;
    }
    .close-btn {
      position: absolute;
      right: -5%;
      top: 0;
      height: 36px;
      width: 36px;
      border: 2px solid #fff;
      border-radius: 50%;
      outline: 0;
      background-color: rgb(0, 0, 0);
      opacity: 0.2;
      cursor: pointer;
      img {
        vertical-align: middle;
      }
    }
  }
  .land-select {
    font-size: 14px;
    font-weight: 400;
    color: #64c3a4;
    cursor: pointer;
  }
}
</style>
